import styled from 'styled-components';

const StyledFormlabel = styled.label`
  color: #333;
  font-size: 14px;
  font-weight: 500;
`;

export default StyledFormlabel;
